<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-cascader
      v-model="siteDevice"
      size="small"
      :options="filterSites"
      :show-all-levels="false"
      :props="props"
      placeholder="请选择站房设备"
      @change="onCheck"
    ></el-cascader>

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      style="margin-left:1rem;"
      @click="getData()"
    >查询</el-button>
    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <display-type
          :default-display-type.sync="displayType"
          style="margin-left:20px;"
          @change="onDisplayTypeChanged"
        />
      </template>

      <h3 style="text-align: center;margin: 0">{{currentSite}}</h3>
      <data-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="headerColumns"
        :data="dataList"
        :pagination="pagination"
        :highlight-data-time="''"
        selected-style
      />

      <parameter-chart
        v-else
        :data="dataList"
        :device-status-unit-map="deviceStatusUnitMap"
        :device-status-map="deviceStatusMap"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../components/Data/Query/SiteQuery'
import BaseSiteFactorData from '../../BaseSiteFactorData'
import DataWrapper from '../../../components/Data/DataWrapper'
import DisplayType from '../../../components/Data/DisplayType'
import DeviceCategoryConfig from '../../../model/DeviceCategoryConfig'
import ParameterChart from './ParameterChart'
import CSVDownloader from '../../../utils/CSVDownloader'

export default {
  name: 'QCAnalysisKeyParameter',
  routeInfo: {
    label: '状态关键参数',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {DataTimeQuery, SiteQuery, DataWrapper, DisplayType, ParameterChart},
  data () {
    return {
      props: {
        children: 'devices',
        value: 'id',
        label: 'name'
      },
      currentSite: '',
      pagination: {
        no: 1,
        size: 24
      },
      displayType: 2,
      dataTableKey: 0,
      siteDevice: [],
      normalData: [],
      headerColumns: [],
      dataList: [],
      deviceStatusUnitMap: {},
      deviceStatusMap: {}
    }
  },
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false)
      ]
    },
    filterSites () {
      let filterSites = JSON.parse(JSON.stringify(this._filterSites))
      if (!filterSites.length) {
        return []
      }

      let {deviceStatusMap} = this
      return filterSites.map(item => {
        let devices = []
        item.devices.forEach(el => {
          if (deviceStatusMap[el.id] && deviceStatusMap[el.id].length > 0) {
            devices.push(el)
          }
        })

        if (devices.length > 0) {
          return {
            ...item,
            devices: devices
          }
        }
      }).filter(Boolean)
    },
    filterSiteDeviceMap () {
      let data = Object.values(this.filterSiteMap).reduce((siteMap, item) => {
        siteMap[item.id] = item

        siteMap[item.id].devicesMap = item.devices.reduce((map, el) => {
          map[el.id] = el

          return map
        }, {})

        return siteMap
      }, {})

      return data
    }
  },
  methods: {
    onCheck () {
      let {siteDevice, filterSiteMap} = this
      let siteId = siteDevice[0]
      this.currentSite = filterSiteMap[siteId].name
      this.query.siteIds = [siteId]
    },
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length === 0) {
        return
      }

      let {query: {siteIds}} = this

      if (siteIds.length === 0) {
        siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        this.siteDevice = [filterSites[0].id, filterSites[0].devices[0].id]
        this.currentSite = filterSites[0].name
      }

      this.afterSetSiteIds()
    },
    afterSetSiteIds () {
      if (this.setOther()) {
        this.onCheck()
        this.setCurrentQuery()
        this.getData()
      }
    },
    setQuery (query) {
      delete query.dataType
      delete query.isAuditCompleted
      delete query.isGetInvalidData
      delete query.factorIds
      let {deviceStatusMap} = this
      let siteDeviceId = this.siteDevice[1]
      let deviceStatusIds = []

      if (deviceStatusMap[siteDeviceId] && deviceStatusMap[siteDeviceId].length > 0) {
        deviceStatusMap[siteDeviceId].forEach(item => {
          if (item.isImportance) {
            deviceStatusIds.push(item.deviceStatusId)
          }
        })
      }

      return {
        ...query,
        statusIds: deviceStatusIds
      }
    },
    getDeviceStatusMap () {
      this.changeLoadStatus(true)
      this.$api.SiteDeviceStatus.getList().then(data => {
        this.deviceStatusMap = data.reduce((map, el) => {
          if (!map[el.siteDeviceId]) {
            map[el.siteDeviceId] = []
          }

          if (el.isImportance && el.status) {
            map[el.siteDeviceId].push(el)
          }

          return map
        }, {})
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getData () {
      let query = this.setQuery(this.query)
      if (!query.statusIds.length) {
        this.$notify.error({
          title: '错误',
          position: 'bottom-right',
          message: '该站点下无已启用的关键参数'
        })
        return
      }
      this.changeLoadStatus(true)

      this.$api.StatusData.getKeyParameter(query).then(data => {
        this.setTableHeader(query)
        if (!data.length) {
          this.normalData = []
          this.dataList = []
          if (this.displayType === 1) {
            this.renderTable()
          }
          return
        }
        this.normalData = Object.freeze(data)
        if (this.displayType === 1) {
          this.formaterData(data, query)
          this.renderTable()
        } else {
          this.dataList = data
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setTableHeader (query) {
      let {statusIds} = query
      let {deviceStatusUnitMap} = this

      let columns = statusIds.map(el => {
        return {
          id: el,
          name: deviceStatusUnitMap[el].name + `${deviceStatusUnitMap[el].unit ? '(' + deviceStatusUnitMap[el].unit + ')' : ''}`,
          width: 160,
          align: 'left'
        }
      })

      let fixedColumns = [{
        id: 'dataTime',
        name: '时间',
        width: 180,
        align: 'left',
        fixed: true
      }, {
        id: 'siteDeviceName',
        name: '站点设备',
        width: 160,
        align: 'left',
        fixed: true
      }]
      this.headerColumns = fixedColumns.concat(columns)
    },
    formaterData (data, query) {
      let {statusIds} = query
      let {filterSiteDeviceMap} = this
      // let deviceStatusMap = Object.values(this.deviceStatusMap).map(el => el).flat().reduce((map, el) => {
      //   map[el.deviceStatusId] = el

      //   return map
      // }, {})

      let keys = {}
      statusIds.forEach(item => {
        keys[item] = '--'
      })

      let dataTimeMap = data.reduce((map, el) => {
        if (!map[el.dataTime]) {
          map[el.dataTime] = {
            dataTime: el.dataTime,
            siteDeviceName: filterSiteDeviceMap[el.siteId].devicesMap[el.siteDeviceId].name,
            ...keys,
            data: []
          }
        }
        map[el.dataTime].data.push(el)

        return map
      }, {})

      let temp = Object.values(dataTimeMap).map(el => {
        if (el.data.length > 0) {
          el.data.forEach(item => {
            el[item.deviceStatusId] = item.value
          })

          return {
            ...el
          }
        }
      })
      this.dataList = temp
    },
    renderTable () {
      setTimeout(() => {
        this.$refs['dataTable'].doLayout()
      }, 10)
    },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime}, headerColumns, normalData} = this
      let filename = `${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}状态关键参数`
      let headerData = headerColumns.map(el => el.name)
      let query = this.setQuery(this.query)

      let {statusIds} = query
      let {filterSiteDeviceMap} = this

      let keys = {}
      statusIds.forEach(item => {
        keys[item] = '--'
      })

      let dataTimeMap = normalData.reduce((map, el) => {
        if (!map[el.dataTime]) {
          map[el.dataTime] = {
            dataTime: el.dataTime,
            siteDeviceName: filterSiteDeviceMap[el.siteId].devicesMap[el.siteDeviceId].name,
            ...keys,
            data: []
          }
        }
        map[el.dataTime].data.push(el)

        return map
      }, {})

      let temp = Object.values(dataTimeMap).map(el => {
        if (el.data.length > 0) {
          el.data.forEach(item => {
            el[item.deviceStatusId] = item.value
          })

          return {
            ...el
          }
        }
      })

      let columnData = []
      temp.forEach(el => {
        let data = [el.dataTime, el.siteDeviceName]
        statusIds.forEach(key => {
          data.push(el[key])
        })
        columnData.push(data)
      })

      CSVDownloader([headerData, ...columnData], filename)
    },
    // JSON 按属性去重 data（去重的JSON） Name（属性名）
    FilterByName (data, Name) {
      let dest = []

      for (let i = 0; i < data.length; i++) {
        let ai = data[i]

        if (i === 0) {
          dest.push(ai)
        } else {
          let filterData = dest.filter(function (e) {
            return e[Name] === ai[Name]
          })

          if (filterData.length === 0) {
            dest.push(ai)
          }
        }
      }
      return dest
    },
    onDisplayTypeChanged (displayType) {
      let {normalData} = this
      if (displayType === 1) {
        setTimeout(() => {
          let query = this.setQuery(this.query)
          this.setTableHeader(query)
          this.formaterData(normalData, query)
          this.renderTable()
        }, 0)
      } else {
        this.dataList = normalData
      }
    },
    getDeviceStatus () {
      this.$api.DeviceStatus.getList().then(data => {
        this.deviceStatusUnitMap = data.reduce((map, el) => {
          map[el.id] = el

          return map
        }, {})
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  },
  created () {
    this.getDeviceStatusMap()
    this.getDeviceStatus()
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  /deep/ .data-wrapper-body {
    gap: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/01KeyParameter/index.vue